import API from "../../Api/Api";
import { API_END_POINT } from "../../Api/EndPoints";
import { isDefined } from "../../Utils";

export const getInterlocutors = (prospectId, signal) => async (dispatch) => {
  if (!isDefined(prospectId)) return;
  try {
    dispatch({ type: "INTERLOCUTORS_LOADING" });
    const { data } = await API.get(`${API_END_POINT}api/interlocutors`, {
      params: {
        fields: ["id", "firstName", "lastName"],
        filters: {
          prospect: {
            id: {
              $eq: prospectId,
            },
          },
        },
      },
      signal,
    });
    dispatch({ type: "INTERLOCUTORS_SUCCESS", payload: data?.data });
  } catch (error) {
    if (error.name === "CanceledError") return;
    dispatch({ type: "INTERLOCUTORS_ERROR" });
  }
};
